import { Map } from "immutable";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { senecaSubjectsList } from "@seneca/tutoring-service-consts";

import { fetchAllTagsIfNotFetched } from "seneca-common/features/course-discovery/tags-feature/service";
import { getAllTags } from "seneca-common/features/course-discovery/tags-feature/state";
import Tag from "seneca-common/features/course-discovery/tags-feature/state/models/Tag";
import {
  useSelector,
  useSelectorOnCondition
} from "seneca-common/utils/hooks/selectors";

import { getRegion } from "features/regions/selectors";

export type Subject = {
  id: string;
  name: string;
};

export default function useGetSubjects(): Subject[] {
  const dispatch = useDispatch();

  const region = useSelector(getRegion);
  const useSenecaSubjects = region !== "GB";

  const allTags = useSelectorOnCondition(useSenecaSubjects, getAllTags);

  useEffect(() => {
    if (useSenecaSubjects) dispatch(fetchAllTagsIfNotFetched());
  }, [useSenecaSubjects, dispatch]);

  return useSenecaSubjects
    ? getSenecaSubjectsFromTags(allTags)
    : getGoStudentSubjects();
}

export function getGoStudentSubjects() {
  const otherSubject = "Other";
  const subjectsList = senecaSubjectsList.filter(
    subject => subject !== otherSubject
  );

  const subjects = subjectsList.map(subjectName => ({
    id: subjectName,
    name: subjectName
  }));

  return [...subjects, { id: otherSubject, name: otherSubject }];
}

function getSenecaSubjectsFromTags(
  allTags: Map<string, Tag> | null
): Subject[] {
  return allTags
    ? (allTags
        .toList()
        .filter(tag => tag.details.get("isSubject"))
        .map(tag => ({ id: tag.id, name: tag.text }))
        .toArray() as Subject[])
    : [];
}
